import React from 'react'
import moment from 'moment'

const GreetingTag = () => {
  let hour = Number(moment(new Date()).format('HH'))
  let name = ''
  switch (hour) {
    case 4:
      name = 'Chào buổi sáng ✋'
      break
    case 5:
      name = 'Chào buổi sáng ✋'
      break
    case 6:
      name = 'Chào buổi sáng ✋'
      break
    case 7:
      name = 'Chào buổi sáng ✋'
      break
    case 8:
      name = 'Chào buổi sáng ✋'
      break
    case 9:
      name = 'Chào buổi sáng ✋'
      break
    case 10:
      name = 'Chào buổi sáng ✋'
      break
    case 11:
      name = 'Chào buổi sáng ✋'
      break
    case 12:
      name = 'Chào buổi chiều ✋'
      break
    case 13:
      name = 'Chào buổi chiều ✋'
      break
    case 14:
      name = 'Chào buổi chiều ✋'
      break
    case 15:
      name = 'Chào buổi chiều ✋'
      break
    case 16:
      name = 'Chào buổi chiều ✋'
      break
    case 17:
      name = 'Chào buổi chiều ✋'
      break
    default:
      name = 'Chào buổi tối ✋'
  }
  return <span className="text-xs text-[#A2A2A2]">{name}</span>
}
export default GreetingTag
